import React, { useState } from 'react';
import { Star } from 'lucide-react';

const ReviewCard = ({ review }) => {
  const [expanded, setExpanded] = useState(false);
  const truncatedReview = review.review.split(" ").slice(0, 40).join(" ");
  const needsTruncation = review.review.split(" ").length > 40;

  return (
    <div className="bg-white rounded-lg p-3 md:p-4 shadow-md border border-yellow-100 h-full flex flex-col">
      {/* Stars at the top */}
      <div className="flex gap-1 mb-2">
        {[...Array(Math.round(review.rating))].map((_, i) => (
          <Star
            key={i}
            className="w-3 h-3 md:w-4 md:h-4 fill-yellow-400 text-yellow-400"
          />
        ))}
      </div>

      {/* Review text in the middle */}
      <div className="text-gray-600 mb-3 flex-grow">
        <p className="text-xs md:text-sm font-bold">
          {expanded ? review.review : truncatedReview}
          {!expanded && needsTruncation ? "..." : ""}
        </p>
        {needsTruncation && (
          <button
            type="button"
            onClick={() => setExpanded(!expanded)}
            className="text-red-500 hover:text-red-600 font-medium mt-1 text-xs md:text-sm"
          >
            {expanded ? "Show Less" : "Read More"}
          </button>
        )}
      </div>

      {/* User info always at the bottom */}
      <div className="flex items-center gap-2 md:gap-3 mt-auto">
        <div className="min-w-8 w-8 h-8 md:min-w-10 md:w-10 md:h-10 bg-gradient-to-r from-red-500 to-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-white text-sm md:text-base font-bold">
            {review.name[0]}
          </span>
        </div>
        <div className="min-w-0 flex-1">
          <p
            className="font-bold text-gray-800 text-xs md:text-sm truncate"
            title={review.name}
          >
            {review.name.length > 15
              ? review.name.substring(0, 15) + "..."
              : review.name}
          </p>
          <p className="text-xs text-gray-500 truncate">
            Verified Customer from{" "}
            <span className="font-bold">{review.country || "USA"}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;